import http from '@/services/http'
import { userUrl, udbUrl } from '@/services/url'
import type * as Types from './types'
export * from './types'
/** 查询该邮箱是否禁用 */
export const checkEmailAuthApi = async (data) => await http.admin.post(userUrl.checkEmailAuth, data)
/**
 * 获取个人信息 :http://api-doc-sl.inshopline.com/#/project/80/feature%2F20210907_v1.0.0/interface/11189cf8e3597e112553c69653fc43cf
 * */

export const getUerInfo = async () => await http.admin.post<Types.UserInfo>(userUrl.getUerInfo)

export const loginWithTicketApi = (data) => http.udb.get('/udb/lgn/cas/callback.do', { params: { ...data } })

export const logoutApi = (data) => http.udb.get(udbUrl.logout, { params: { ...data } })

/**
 * 修改个人信息：http://api-doc-sl.inshopline.com/#/project/80/feature%2F20220727_1187_shipment_info/interface/bff8080b4bd16b3717c86752d93c1936
 * @param data
 * @returns
 */
export const updateInfoApi = async (data: Types.UpdateInfoDto) => await http.admin.post<Types.UserInfo>(userUrl.updateInfo, data)

// appealConfirm
export const userAppealConfirm = async (data) => await http.admin.post(userUrl.userAppealConfirm, data, { withCredentials: false })

/** 商家注销 */
export const cancelSeller = async (data) => await http.admin.post(userUrl.sellerCancel, data)

/** 商家注销邮箱确认 */
export const sellerCancelConfirm = async (data) => await http.admin.post(userUrl.sellerCancelConfirm, data)

/** 商家邮件预校验 */
export const checkEmail = async () => await http.admin.get(userUrl.checkEmail)

/** 更新个人信息中的 notification_email */
export const updateNotificationEmail = async (data) => await http.admin.post(userUrl.updateNotificationEmail, data)

/** 获取用户的fk */
export const fetchFK = () => http.admin.post('/api/crm/admin/subscription/rights/feature-keys')
